import React, { useCallback } from 'react';

import { defineMessages, useIntl } from 'react-intl';

import { Create } from '@atlaskit/atlassian-navigation';
import { useDialog } from '@atlassian/ptc-common';

import LazyCreateTeamDialog from '../../../../../../common/ui/CreateTeamDialog';
import { useStandaloneFlagActions } from '../../../../../../controllers/flags';
import { useOrgIdState } from '../../../../../../controllers/org-id';
import { useSiteStandaloneApp } from '../../../../../../controllers/site-standalone-app';

export const messages = defineMessages({
	createTeamButtonLabel: {
		id: 'ptc-directory-ui.top-nav.create-team-button.label',
		defaultMessage: 'Create team',
		description: 'Label for the create team button in the top nav',
	},
});

export const CreateTeamButton = (): React.JSX.Element => {
	const [, { addFlag }] = useStandaloneFlagActions();
	const intl = useIntl();
	const [{ cloudId }] = useSiteStandaloneApp();
	const [{ orgId }] = useOrgIdState();

	const { openDialog } = useDialog();

	const onClick = useCallback(() => {
		openDialog(LazyCreateTeamDialog, {
			addFlag,
			cloudId,
			orgId,
		});
	}, [addFlag, cloudId, openDialog, orgId]);

	return <Create text={intl.formatMessage(messages.createTeamButtonLabel)} onClick={onClick} />;
};
